export default __webpack_public_path__ + "static/header-video-blob-a9b8d5bdb79c5cb02a676635d9bc5ed0.png";